import Axios from "axios";

const AppInstance = Axios.create({
  baseURL: "/api",
  withCredentials: true,
});

export { AppInstance };
